/**
 * Slug generator for website CONTENT (blogs, regions, suburbs, charity partners).
 *
 * Deliberately NOT `stringToKey`. That helper only lowercases and dashes
 * whitespace, and is mirrored byte-for-byte in the XLSX util for supplier
 * category matching — changing it would move that behaviour too. picaluna-v3
 * keys its snapshot on a stricter slugify (`scripts/sync-conductor.ts`), so the
 * two diverged the moment a name contained anything but letters, digits and
 * single spaces:
 *
 *   "Sydney - Inner West"  stringToKey → sydney---inner-west
 *                          v3 slugify  → sydney-inner-west
 *
 * Both pass the editor's old `^[a-z0-9-]+$` and the server's scope grammar, so
 * a per-item publish returned 202, matched nothing in the snapshot, wrote no
 * change — and still reported success and cleared the "suburbs changed" badge.
 * Silent no-ops are the worst failure this pipeline can produce, so this mirrors
 * v3's slugify exactly. Keep the two in step.
 */
export function contentSlug(input: string): string {
  return (input || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // strip combining accents
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');
}

/**
 * Slugs the pipeline can actually address: lowercase alphanumeric groups joined
 * by single dashes, no leading/trailing dash. Matches the server's scope token
 * grammar, so anything that saves can also be published on its own.
 */
export const CONTENT_SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;
